import React from 'react';
import TextField from "@material-ui/core/TextField";

// import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";

const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

function DateTimepicker(props) {
    const { disabled, field, input } = props;

    if (field.type === 'number') {
        input.min = 1;
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                renderInput={(props) => <TextField
                    variant={'outlined'}
                    {...props}
                    disabled={disabled}
                />}
                label={field.required ? <>{field.label} *</> : field.label}
                inputFormat="dd.MM.yyyy HH:mm"
                mask={'__.__.____ __:__'}
                ampm={false}
                ampmInClock={false}
                {...input}
                value={input.value ? dayjs(input.value, 'DD.MM.YYYY HH:mm').toDate() : null}
                onChange={(value, ...rest) => {
                    if(Object.prototype.toString.call(value) === "[object Date]" && !isNaN(value.getTime())) {
                        const date = dayjs(value).format('DD.MM.YYYY HH:mm');
                        input.onChange(date);
                        return value;
                    }
                    input.onChange(null);
                    return value;
                }}
                disabled={disabled}
                disablePast={!field.allowPast}
            />
        </LocalizationProvider>
    );
}

export default DateTimepicker;
